import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Tooltip } from '@fuxi/eevee-ui';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { COOPERATE_MAIL } from '@portalCommon/constants';

import classnames from 'classnames/bind';
import { OptimizedImg } from '@commonPackage/components';
import styles from './index.module.less';

const cx = classnames.bind(styles);

export default function Cooperation({ className }: { className?: string }) {
  const { t } = useTranslation();
  const [text, setText] = useState<string>('contactUs.cooperate.copy');

  const cooperationList = [
    {
      title: t('contactUs.cooperate.fundTitle'),
      url: COOPERATE_MAIL.FUND,
      img: 'https://static.fuxi.netease.com/yaotai/portal/20221101/l9y0mwk0_405647.png',
    },
    {
      title: t('contactUs.cooperate.mediaTitle'),
      url: COOPERATE_MAIL.MEDIA,
      img: 'https://static.fuxi.netease.com/yaotai/portal/20221101/l9y0n0vr_411255.png',
    },
    {
      title: t('contactUs.sale.adviceTitle'),
      url: COOPERATE_MAIL.ADVICE,
      img: 'https://static.fuxi.netease.com/yaotai/portal/20221101/l9y0mysm_408550.png',
    },
  ];
  return (
    <div className={cx('cooperation-wrapper', className)}>
      {cooperationList.map(item => (
        <div key={item.url} className={cx('list-item')}>
          <div className={cx('title')}>{item.title}</div>

          <div className={cx('url')}>
            <span className={cx('url-content')}>{item.url}</span>
            <Tooltip
              placement="right"
              title={t(text)}
              mouseLeaveDelay={1}
              onOpenChange={() => setText('contactUs.cooperate.copy')}>
              <CopyToClipboard key="copy" text={item.url} onCopy={() => setText('contactUs.cooperate.cpySucc')}>
                <span>
                  <div className={cx('copy-btn')} />
                </span>
              </CopyToClipboard>
            </Tooltip>
          </div>
          <OptimizedImg width={142} loading="lazy" src={item.img} alt="" className={cx('img')} />
        </div>
      ))}
    </div>
  );
}
